var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05555 0C2.59531 0 2.22221 0.373096 2.22221 0.833333V2.5C2.22221 2.96024 2.59531 3.33333 3.05555 3.33333C3.51578 3.33333 3.88888 2.96024 3.88888 2.5V2.22226H9.44444C9.75127 2.22226 10 1.97353 10 1.6667C10 1.35988 9.75127 1.11115 9.44444 1.11115H3.88888V0.833334C3.88888 0.373096 3.51578 0 3.05555 0ZM3.05555 6.66664C2.59531 6.66664 2.22221 7.03974 2.22221 7.49997V9.16664C2.22221 9.62688 2.59531 9.99997 3.05555 9.99997C3.51578 9.99997 3.88888 9.62688 3.88888 9.16664V8.8889H9.44444C9.75127 8.8889 10 8.64017 10 8.33334C10 8.02652 9.75127 7.77779 9.44444 7.77779H3.88888V7.49997C3.88888 7.03974 3.51578 6.66664 3.05555 6.66664ZM8.33333 4.99997C8.33333 5.61362 7.83587 6.11108 7.22222 6.11108C6.60857 6.11108 6.11111 5.61362 6.11111 4.99997C6.11111 4.38632 6.60857 3.88885 7.22222 3.88885C7.83587 3.88885 8.33333 4.38632 8.33333 4.99997ZM0.555555 1.11115H1.66666V2.22226H0.555555C0.24873 2.22226 0 1.97353 0 1.6667C0 1.35988 0.248731 1.11115 0.555555 1.11115ZM0.555555 7.77779H1.66666V8.8889H0.555555C0.24873 8.8889 0 8.64017 0 8.33334C0 8.02652 0.248731 7.77779 0.555555 7.77779ZM0.555555 5.55554H5.65038C5.58897 5.38178 5.55556 5.19481 5.55556 5.00003C5.55556 4.80521 5.58898 4.61821 5.65041 4.44443H0.555555C0.248731 4.44443 0 4.69316 0 4.99998C0 5.30681 0.24873 5.55554 0.555555 5.55554ZM8.79407 5.55554C8.85548 5.38178 8.88889 5.19481 8.88889 5.00003C8.88889 4.80521 8.85547 4.61821 8.79404 4.44443H9.44444C9.75127 4.44443 10 4.69316 10 4.99998C10 5.30681 9.75127 5.55554 9.44444 5.55554H8.79407Z",
    fill: "url(#paint0_linear_26853_226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26853_226",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.ce26923e301f434454e333273a76650d.svg";
export { ForwardRef as ReactComponent };